import usePosUserSettingsQuery from "@/shared/queries/pos/usePosUserSettingsQuery";
import usePosUserSettingsPost from "./usePosUserSettingsPost";

/**
 * Stores the chosen card terminal in the account based POS user settings.
 * The settings endpoint replaces the full object, so the current settings are
 * sent along. `item_id` is left out (like the settings form does): when the
 * user has no settings yet it is not theirs, and the backend resolves the
 * record itself. The client-side derived field is left out as well.
 */
const useSavePosTerminal = () => {
  const settingsQuery = usePosUserSettingsQuery();
  const mutation = usePosUserSettingsPost();

  const saveTerminal = async (terminalId: string) => {
    const settings = settingsQuery.data;
    if (!settings) return;

    const { item_id, column_count_per_category_array, ...currentSettings } =
      settings;
    await mutation.mutateAsync({
      ...currentSettings,
      default_pos_terminal_id: terminalId,
    });
    await settingsQuery.refetch();
  };

  return { saveTerminal, isPending: mutation.isPending };
};

export default useSavePosTerminal;
